import { DonationFormBaseValues } from '@/app/components/DonationForm/types';
import { useDebouncedEffect } from '@/app/hooks/useDebouncedEffect';
import { usePostCreateDonation } from '@/src/api/client';
import { PostCreateDonationDryRun } from '@/src/api/models';
import { CreateDonationRequest } from '@/src/api/models/CreateDonationRequest';
import { useEffect } from 'react';

type UseBackendValidationParams = {
  formValues: DonationFormBaseValues;
  enabled: boolean;
  transformData: (data: DonationFormBaseValues) => CreateDonationRequest;
};

export const useBackendValidation = ({ formValues, enabled, transformData }: UseBackendValidationParams) => {
  const { mutateAsync: postCreationDonation, isPending, error, reset, status } = usePostCreateDonation();
  const { amount, tipAmount, customTipAmount, ...restFormValues } = formValues;
  useEffect(() => {
    if (!enabled) {
      reset();
    }
  }, [enabled]);

  // debounce změn vstupu
  useDebouncedEffect(
    () => {
      if (enabled && restFormValues) {
        postCreationDonation({
          params: {
            dryRun: PostCreateDonationDryRun.NUMBER_1,
          },
          data: transformData(formValues),
        });
      }
    },
    [JSON.stringify(restFormValues), enabled],
    300,
  );

  return {
    isValid: status !== 'error' && status !== 'idle',
    isLoading: isPending,
    error,
  };
};
